import { BADGE_DIAMETER_MM, FULL_DIAMETER_MM, DPI, MM_PER_INCH } from './geometry';
import type { SlotImage, FitTarget } from '../types';

const minPx = (mm: number): number => Math.ceil((mm * DPI) / MM_PER_INCH);

export const MIN_PX_CENTRE = minPx(BADGE_DIAMETER_MM); // 520
export const MIN_PX_BLEED = minPx(FULL_DIAMETER_MM);   // 638

export type DpiCheck = {
  ok: boolean;
  required: number;
  actual: number | null;
};

export function checkDpi(image: SlotImage, fitTarget: FitTarget): DpiCheck {
  if (image.kind === 'vector') {
    return { ok: true, required: 0, actual: null };
  }
  const required = fitTarget === 'centre' ? MIN_PX_CENTRE : MIN_PX_BLEED;
  const actual = Math.min(image.naturalWidth!, image.naturalHeight!);
  return { ok: actual >= required, required, actual };
}
